import { useId } from 'react'

const Dropper = ({
  label = 'Dropper',
  liquidColor = '#FEF3C7',
  onClick,
  active = false,
  disabled = false,
  dropping = false
}) => {
  const id = useId()

  return (
    <svg
      viewBox="0 0 60 130"
      width={55}
      height={115}
      onClick={disabled ? undefined : onClick}
      style={{
        cursor: disabled ? 'default' : onClick ? 'pointer' : 'default',
        opacity: disabled ? 0.5 : 1,
        transition: 'all 0.2s ease'
      }}
    >
      <defs>
        {/* Rubber bulb gradient */}
        <radialGradient id={`bulb-${id}`} cx="50%" cy="30%" r="60%">
          <stop offset="0%" stopColor="#5A6778" />
          <stop offset="70%" stopColor="#3D4758" />
          <stop offset="100%" stopColor="#2A3544" />
        </radialGradient>

        {/* Bulb highlight */}
        <radialGradient id={`bulb-hi-${id}`} cx="30%" cy="20%" r="40%">
          <stop offset="0%" stopColor="rgba(255,255,255,0.4)" />
          <stop offset="100%" stopColor="rgba(255,255,255,0)" />
        </radialGradient>

        {/* Glass tube gradient */}
        <linearGradient id={`glass-${id}`} x1="0%" y1="0%" x2="100%" y2="0%">
          <stop offset="0%" stopColor="rgba(200,220,240,0.7)" />
          <stop offset="20%" stopColor="rgba(255,255,255,0.4)" />
          <stop offset="50%" stopColor="rgba(230,240,250,0.25)" />
          <stop offset="80%" stopColor="rgba(255,255,255,0.35)" />
          <stop offset="100%" stopColor="rgba(200,220,240,0.6)" />
        </linearGradient>

        {/* Liquid gradient */}
        <linearGradient id={`liquid-${id}`} x1="0%" y1="0%" x2="0%" y2="100%">
          <stop offset="0%" stopColor={liquidColor} stopOpacity="0.85" />
          <stop offset="100%" stopColor={liquidColor} stopOpacity="1" />
        </linearGradient>

        {/* Drop shadow */}
        <filter id={`shadow-${id}`} x="-20%" y="-10%" width="140%" height="120%">
          <feDropShadow dx="2" dy="3" stdDeviation="2" floodOpacity="0.25"/>
        </filter>
      </defs>

      {/* Active glow */}
      {active && (
        <ellipse
          cx="30" cy="50" rx="26" ry="45"
          fill="none"
          stroke="var(--primary)"
          strokeWidth="2.5"
          style={{ animation: 'glow 1.5s ease-in-out infinite' }}
        />
      )}

      <g filter={`url(#shadow-${id})`}>
        {/* Rubber bulb */}
        <ellipse
          cx="30" cy="18"
          rx="15" ry="17"
          fill={`url(#bulb-${id})`}
        />

        {/* Bulb highlight */}
        <ellipse
          cx="24" cy="12"
          rx="6" ry="7"
          fill={`url(#bulb-hi-${id})`}
        />

        {/* Bulb bottom ring */}
        <ellipse
          cx="30" cy="33"
          rx="8" ry="3"
          fill="#3D4758"
        />

        {/* Neck connector */}
        <rect
          x="22" y="33" width="16" height="8"
          fill="#4A5568"
          rx="2"
        />

        {/* Glass tube body */}
        <path
          d="M20 41 L20 85 Q20 90 23 94 L25 97 L35 97 L37 94 Q40 90 40 85 L40 41 Z"
          fill={`url(#glass-${id})`}
          stroke="#7A9BB8"
          strokeWidth="1.5"
        />

        {/* Liquid inside tube */}
        <path
          d="M23 48 L23 82 Q23 86 25 90 L35 90 Q37 86 37 82 L37 48 Z"
          fill={`url(#liquid-${id})`}
        />

        {/* Glass tip (tapered) */}
        <path
          d="M25 97 L27 108 Q30 114 33 108 L35 97"
          fill={`url(#glass-${id})`}
          stroke="#7A9BB8"
          strokeWidth="1.5"
        />

        {/* Tip opening */}
        <ellipse
          cx="30" cy="110"
          rx="2" ry="1"
          fill="#5A7A95"
        />
      </g>

      {/* Glass shine */}
      <line
        x1="24" y1="45" x2="24" y2="85"
        stroke="rgba(255,255,255,0.6)"
        strokeWidth="2"
        strokeLinecap="round"
      />

      {/* Dropping animation */}
      {dropping && (
        <ellipse
          cx="30" cy="115" rx="3" ry="4"
          fill={liquidColor}
          style={{ animation: 'droplet 0.4s ease-out' }}
        />
      )}

      {/* Label - larger and clearer */}
      <text
        x="30" y="127"
        fontSize="11"
        fill="var(--text-primary)"
        textAnchor="middle"
        fontWeight="600"
      >
        {label}
      </text>
    </svg>
  )
}

export default Dropper
